export default [
  { label: "REDES SOCIALES", value: "REDES SOCIALES" },
  { label: "VALLA PUBLICITARIA", value: "VALLA PUBLICITARIA" },
  { label: "REFERIDO POR UN AMIGO", value: "REFERIDO POR UN AMIGO" },
  { label: "CENTRO COMERCIAL", value: "CENTRO COMERCIAL" },
  { label: "PAGINA WEB", value: "PAGINA WEB" },
  { label: "OTROS", value: "OTROS" },
];
